module.exports = __webpack_public_path__ + "static/Moderat-Medium-6446d634272945fe29b38a0fce7fdaf3.woff";